import styled from '@emotion/styled';

export const Input = styled.input<{ invalid?: boolean }>`
  font: var(--font-label-xl-light);
  margin-top: var(--spacing-4);
  border: 1px solid var(--color-secondary-80);
  padding: var(--spacing-16);
  color: var(--color-black);
  outline: none;
  border-radius: var(--border-radius-m);
  display: block;
  width: 100%;
  box-sizing: border-box;

  &[aria-invalid='true'] {
    border-color: var(--color-error-40);
  }
`;

export const Info = styled.p`
  font: var(--font-body-s-light);
  margin-top: var(--spacing-8);
`;
